import LoginComponent from "./LoginComponent";
import { navratNaHlavniStrankuPublic, preloadScript, preloadCSS } from "../../utils/common.mjs";
import { settings } from '../../config/settingsFactory.mjs';
import { getValidSetting } from '../../utils/common.mjs';

function renderLoginComponent(userData, event) {

    preloadScript('/assets/formio/formio.full.min.js');
    preloadCSS('/assets/formio/formio.full.min.css');
    preloadCSS('/assets/formio/bootstrap.min.css');
    preloadCSS('/assets/formio/font/bootstrap-icons.min.css');

    if (event) event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    userData = userData || urlParams.get('userData') || 'zivotniSituace';

    // Find the service or link by its code
    const service = settings.clientSettings?.openServices?.flatMap(group => group.services)?.find(service => String(service.code).toUpperCase() === String(userData).toUpperCase()) || settings.clientSettings?.openLinks?.find(link => String(link.code).toUpperCase() === String(userData).toUpperCase());

    const zalozkyDiv = document.querySelector('#divZalozky');
    zalozkyDiv.style.display = 'none';
    
    const div = document.querySelector('#divFormio');
    div.innerHTML = "";
    
    const loginComponentNode = LoginComponent({
        userData: userData || "zivotniSituace",
        service: service ? {code: service.code, description: getValidSetting(service.description, "Služba", "settings.clientSettings.openServices.group.service.description, serviceCode: " + service.code) } : false,
        productionMode: settings.mode === "PROD",
        niaUrl: getValidSetting(settings.niaUrl,'#','NIA URL link'),
    });
    if (loginComponentNode instanceof Node) {
        div.appendChild(loginComponentNode);
    } else {
        console.error("LoginComponent did not return a valid DOM node.");
    }
    div.style.display = "block";

    const backButtonSignIn = document.getElementById("back-button-sign-in");
    const parentElement = backButtonSignIn.parentElement;

    parentElement.style.position = 'relative';
    backButtonSignIn.style.position = 'absolute';
    backButtonSignIn.style.top = '0px';
    backButtonSignIn.style.right = '0px';

    backButtonSignIn.addEventListener('gov-click', () => {
        navratNaHlavniStrankuPublic();
    })

    // Test/dev rodne-cislo login form. Gated by a Vite `define` so the entire
    // block (including the fakelogin2 URL) is tree-shaken out of PROD bundles.
    if (!__IS_PROD_BUILD__) {
        const rodneCisloPrihlasit = async (event) => {
            event.preventDefault();
            const rc = document.querySelector('#rc');
            const formUserData = document.querySelector('#formUserData');

            console.log("rc.value z rodneCisloPrihlasit: " + rc.value);
            console.log("userData z rodneCisloPrihlasit: " + formUserData.value);

            await fetch("/loginCUZK/fakelogin2?rc=" + rc.value + "&userData=" + formUserData.value).then(response => {
                if (response.redirected) {
                    window.location.href = response.url;
                }
                if (response.status === 204) {
                    window.callToast("error", "solid", 8000, "Uživatel s uvedeným rodným číslem neexistuje v ISKN."); // TOAST
                }
            })
            .catch(function(err) {
                console.error(err + " url: " + window.location.search);
            });
        };

        const rcOdeslat = document.querySelector('#rcOdeslat');
        if (rcOdeslat) {
            rcOdeslat.addEventListener("gov-click", rodneCisloPrihlasit);

            // submit form on enter
            window.addEventListener('keydown', function (e) {
                if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) {
                    if (e.target.nodeName == 'INPUT' && e.target.type == 'text') {
                        e.preventDefault();
                        rodneCisloPrihlasit(event);
                    }
                }
            }, true);
        }
    }
}

export { renderLoginComponent };